module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-branding" roe-class="{\n    \'ggs-gallery-branding_tiny\': $ctrl.isTinyLayout(),\n    \'ggs-gallery-branding_force-show\': $ctrl.ggsProperties.branding_footer_force_show\n  }" roe-class-emitter=":: [\n    $ctrl.isTinyLayout,\n    $ctrl.ggsProperties.key2emitter.branding_footer_force_show\n  ]"><a class="ggs-gallery-branding__link" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getBrandingUrl()"><img class="ggs-gallery-branding__logo" ggs-src="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getBrandingLogo()"><div class="ggs-gallery-branding__text" ggs-tmpl="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.complete_message_bundle.footer_powered_by_text"><span class="ggs-gallery-branding__app-name" ng-bind="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.app_name" ggs-tmpl-value-for="%{app_name}"></span></div></a></div>';
return __p
}